//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import { posts } from '~/config';
import { BuildData, checkBreakpoint, getSeo } from '~/helpers';

export default {
    name: 'GenericaPage',

    async asyncData({ app, $axios, $getIDBySlug, error, redirect, route, store, i18n }) {
        // Save number of sections
        const { slug } = route.params;

        try {
            const optionsCheck = store.getters['options/CHECK_OPTIONS'];

            if (optionsCheck === false) {
                await store.dispatch('options/UPDATE_OPTIONS');
            }

            const postsLength = store.getters['posts/GET_POSTS_COUNT'];

            if (postsLength === 0) {
                await store.dispatch('posts/UPDATE_POSTS');
            }

            if (typeof $getIDBySlug !== 'undefined') {
                const postID = $getIDBySlug(slug) || posts[slug];

                if (!postID || typeof postID !== 'number') {
                    store.dispatch('generica/updateData', null);

                    error({
                        statusCode: 404,
                        message: i18n.t(
                            'Ops, sembra che questa pagina non esista'
                        ),
                    });

                    return;
                }

                const postCall = await $axios.$get(`posts/${postID}`, {
                    params: {
                        culture: i18n.locale,
                    },
                });

                if (postCall.isSuccess === false) {
                    error({
                        statusCode: 404,
                        message: i18n.t(
                            'Ops, sembra che questa pagina non esista'
                        ),
                    });

                    return;
                }

                const post =
                    postCall.isSuccess === true && postCall.payload
                        ? postCall.payload.posts[0]
                        : null;

                if (!post) {
                    error({
                        statusCode: 404,
                        message: i18n.t('Ops, sembra che questa pagina non esista'),
                    });

                    return;
                }

                if (post.post_type === 'immobili') {
                    redirect(301, app.localePath(`/immobili/${slug}`));
                    return;
                }

                const bd = new BuildData(post, 'page');
                const postData = bd.build();

                await store.dispatch('generica/updateData', post);
                await store.dispatch('ui/UPDATE_IS_PAGE_IMMOBILI', false);

                return {
                    postData,
                };
            }

            return {
                postData: null,
            };
        } catch (e) {
            console.error(e);

            error({
                statusCode: 404,
                message: i18n.t('Ops, sembra che questa pagina non esista'),
            });
        }
    },

    data: () => ({
        checkBreakpointUpLg: false,
        post: null,
        postData: null,
        sections: [],
        seo: {
            title: null,
            description: null,
            breadcrumb_title: null,
            is_robots_noindex: null,
            is_robots_nofollow: false,
            is_robots_noarchive: null,
            is_robots_noimageindex: null,
            is_robots_nosnippet: null,
            twitter_title: null,
            twitter_image: null,
            twitter_description: null,
            twitter_image_id: null,
            twitter_image_source: null,
            open_graph_title: null,
            open_graph_description: null,
            open_graph_image: null,
            open_graph_image_id: null,
            open_graph_image_source: null,
            open_graph_image_meta: null,
        },
    }),

    async fetch() {
        this.post = this.$store.state.generica.data;
        let isCoverFirstSection = false;

        if (this.postData) {
            if (this.postData.sections) {
                this.sections = this.postData.sections;
            }

            if (this.postData.seo) {
                this.seo = this.postData.seo;
            }

            if (this.postData.isCoverFirstSection === true) {
                isCoverFirstSection = true;
            }
        }

        console.groupCollapsed('debug coverFirstSection');
        console.log('isCoverFirstSection', isCoverFirstSection);

        await this.$store.dispatch(
            'ui/UPDATE_IS_COVER_FIRST_SECTION',
            isCoverFirstSection
        );

        console.log(
            'this.isCoverFirstSection',
            this.$store.state.ui.isCoverFirstSection
        );

        console.groupEnd();
    },

    head() {
        if (this.seo === null || typeof this.seo === 'undefined') {
            return;
        }

        const fullPath = this.$route.fullPath;

        const baseURL = this.$config.BASE_URL || 'https://www.libertyhomes.it/';

        const currentURL = `${baseURL}${String(fullPath).replace(/^\//, '')}`;

        const headToReturn = getSeo(this.seo, currentURL, true);

        return { ...headToReturn };
    },

    computed: {
        ...mapState({
            isNavOpen: ({ ui }) => ui.isNavOpen,
        }),

        ...mapGetters(['ui/GET_IS_NAV_OPEN']),
    },

    mounted() {
        this.checkBreakpointUpLg = checkBreakpoint.up('lg');
    },

    methods: {
        ...mapActions([
            'ui/UPDATE_IS_COVER_FIRST_SECTION',
            'ui/UPDATE_IS_PAGE_IMMOBILI',
        ]),
    },
};
